<template>
  <Cobrand :affiliates="true">
    <SignModal></SignModal>
    <BusinessSwitchModal></BusinessSwitchModal>
    <TokenExpiryModal></TokenExpiryModal>
    <MarketplaceNav />
    <div data-smooth-scroll="main" class="marketplace-body-footer-container d-flex flex-column vh-100 overflow-x-hidden">
      <div class="d-flex flex-lg-grow-1 align-items-center align-items-lg-start flex-column mb-auto">
        <div class="px-3 px-lg-0 py-lg-0 marketplace-page">
          <slot />
        </div>
      </div>
      <div class="d-flex align-content-between flex-column mt-auto">
        <MarketplaceFooter class="mb-3" />
      </div>
    </div>
  </Cobrand>
</template>

<script>
import SignModal from '~/components/SignModal'
import BusinessSwitchModal from '../components/BusinessSwitchModal'
import TokenExpiryModal from '~/components/TokenExpiryModal.vue'
import MarketplaceFooter from '~/components/marketplace/MarketplaceFooter'
import MarketplaceNav from "~/components/marketplace/MarketplaceNav";
import Cobrand from "~/components/Cobrand";
import { mapState } from 'pinia'
import SmoothScroll from '~/libs/smooth-scroll'
import { useProgressStore } from '~/store/progress'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'

export default {
  components: {
    MarketplaceFooter,
    MarketplaceNav,
    Cobrand,
    SignModal,
    TokenExpiryModal,
    BusinessSwitchModal,
  },
  watch: {
    '$route.path' () {
      SmoothScroll.goTo(0)
      SmoothScroll.scrollElementsTop('[data-smooth-scroll="main"]')
    },
  },
  setup() {
    useHead({
      title: 'Lendio - Renewal Application',
    })
  },
  computed: {
    ...mapState(useRootStore, {
      authUser: (store) => store.authUser
    })
  },
  methods: {
    logout () {
      useRootStore(this.$pinia).logout({ $router: this.$router, path: this.$route && this.$route.path })

      if (process.client) {
        window.logout()
      }
    },
  },
  async mounted () {
    const piniaUserStore = useUserStore(this.$pinia)
    useProgressStore(this.$pinia).fetchProgress()
    await Promise.all([
      piniaUserStore.getBorrowers(),
      piniaUserStore.loadFreshLogin()
    ])

    if (this.authUser) {
      try {
        this.$chatService.show();
      } catch (e) {
        console.warn(e); // throw console warning on exception
      }
    }
  }
}
</script>

<style lang="scss">
.marketplace-body-footer-container {
    @include media-breakpoint-up(lg) {
      padding-left: 400px;
    }
  }
  .marketplace-page {
    width: 100%;
    @include media-breakpoint-down(lg) {
      max-width: 365px;
      margin-top: 90px;
    }
    @include media-breakpoint-up(lg) {
      width: 600px;
      margin-top: 90px; /* Spaced to match .sidebar-nav in MarketplaceSidebar minus back btn and 16 margin */
    }
    .no-value-select {
      color: $type-400
    }
  }
  .no-back-button-padding {
    padding-top: 58px; /* When a back button is included it takes up 58px */
  }

  .marketplace-header {
    :not(h3) {
      color: $type-500
    }
  }

  .marketplace-content {
    > * {
      margin-bottom: 24px;
    }
  }

  .marketplace-content > :last-child {
    margin-bottom: 32px !important;
  }

  .marketplace-content > *:not(.marketplace-content-wide) {
    max-width: 360px;
  }

  .marketplace-content-wide {
    @include media-breakpoint-up(lg) {
      width: 600px
    }
  }
</style>
